import { useCallback } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { usePermissionsContext } from '../../contexts/PermissionsContext';
import { useProductDeleteModal } from '../../contexts/ProductDeleteModalContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const ProductHighlightDeleteButton = () => {
  const {
    hasScope
  } = usePermissionsContext();
  const {
    setIsDeleteModalOpen
  } = useProductDeleteModal();
  const hasPermissionToDeleteProducts = hasScope('product-library-all-delete');
  const handleShowDeleteModal = useCallback(() => {
    setIsDeleteModalOpen(true);
  }, [setIsDeleteModalOpen]);
  if (!hasPermissionToDeleteProducts) {
    return null;
  }
  return /*#__PURE__*/_jsx(Button, {
    use: "unstyled",
    onClick: handleShowDeleteModal,
    "data-test-id": "delete-product-button",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "actions.delete"
    })
  });
};